<template lang="html">
  <modal name="thankyou-modal" height="auto" width="416" :adaptive="true" :maxWidth="416">
    <div class="modal-container">
      <div class="modal-header bold">
        Add Licenses
      </div>
      <div class="line-break-gray" />
      <div class="modal-body">
        <div class="title">
          Thanks for your purchase!
        </div>
        <div class="gap-3x" />
        <div>You can now add more Symbium Build+ users to your organization. We have also sent a receipt for your purchase to your email address.</div>
        <div class="gap-3x" />
        <div>
          If you have any questions,
          <a href="https://symbium.com/contact" class="link-purple active" target="_blank">contact us</a>.
        </div>
      </div>
      <div class="line-break-gray" />
      <div class="modal-footer">
        <SymbiumButton
          kclass="btn-base"
          :isSmall="true"
          :text="'Close'"
          :onClick="close"
        />
      </div>
    </div>
  </modal>
</template>

<script>
import SymbiumButton from 'src/components/common/SymbiumButton.vue'

export default {
  components: { SymbiumButton },
  methods: {
    close() {
      this.$modal.hide('thankyou-modal');
    }
  }
}
</script>

<style lang="scss">
.thankyou-modal {
  .title {
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    letter-spacing: -0.18px;
  }

  .modal-body {
    height: 407px;
  }

  .modal-footer .oval-button {
    padding: 8px 16px;
    margin: 0;

    .text {
      line-height: 14px;
    }
  }
}
</style>
